(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fnf-native-filters"] && !Shopify.designMode) return;
  try {
    (() => {
  const enforceStock = () => {
    document.querySelectorAll('.fnf-filter-values').forEach(group => {
      const labels = Array.from(group.querySelectorAll('label[data-size-rank]'));
      labels.sort((a, b) => Number(a.dataset.sizeRank) - Number(b.dataset.sizeRank));
      labels.forEach(label => group.appendChild(label));
    });
    if (!document.querySelector('[data-fnf-stock-only="true"]')) return;
    const url = new URL(window.location.href);
    const values = url.searchParams.getAll('filter.v.availability');
    if (values.length === 1 && values[0] === '1') return;
    url.searchParams.delete('filter.v.availability');
    url.searchParams.set('filter.v.availability', '1');
    url.searchParams.delete('page');
    window.location.replace(url.toString());
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceStock, { once: true });
  } else {
    enforceStock();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
